<template>
    <div class="micro-card">

        <CCard class="mb-0">
            <CCardHeader>
                <b>
                    <slot name="title">
                        {{ title }}
                    </slot>
                </b>
            </CCardHeader>
            <CCardBody class="p-0" :class="extraBodyClass">
                <slot name="body">
                    This content is in card body component.
                </slot>
            </CCardBody>
        </CCard>
        <p>
            <slot name="description">
                <small>{{ description }}</small>
            </slot>
        </p>
    </div>

</template>

<script>
export default {
    name: "MicroCard",
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        extraBodyClass: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped lang="scss">
.micro-card {
    .card {
        box-shadow: unset;
        -webkit-box-shadow: unset;
        background: transparent;

        .card-body {
            border: 1px solid #000;
            height: 90px;            
            width: 90px;            
            display: flex;
            justify-content: center;
            align-items: center;
            background: #fff;
        }

        .card-header {
            vertical-align: middle;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;            
            padding: 5px;
            text-align: center;
            background: transparent;
        }
    }
}
</style>
